import React from 'react'

import { Col, Form } from '_zari/core'

import { OrigenesContabilidadConstant } from 'constants/index'

import { Select2CentroCostoNivel2 } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CentroCostoNivel2FormGroup = ({ iError, iTouched, setFieldValue, vOrigen, idNodoPadre, iValue, aplicaDestino }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('_idCentroCostoNivel2', salida.value)
      setFieldValue('centroCostoNivel2Info', salida.label)

      KeyEventUtil.leaveOnKeyEvent(
        vOrigen === OrigenesContabilidadConstant.COMPRAS && aplicaDestino ? 'select-cuentaDestino' : 'nuevoasiento-agregar-button'
      )
    },
    [vOrigen, aplicaDestino, setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('_idCentroCostoNivel2', '')
    setFieldValue('centroCostoNivel2Info', '')

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent('select-centroCostoNivel2')
    }, 200)
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='C. COSTO 2' htmlFor='select-centroCostoNivel2' md={12} />
      <Col md={12}>
        {iValue ? (
          <ClearInputGroup id='centroCostoNivel2' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CentroCostoNivel2 id='select-centroCostoNivel2' idNodoPadre={idNodoPadre} onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoNivel2FormGroup)
